import { CUSTOMISATION_CATEGORIES } from "@tfg/types/constants/communication-studio.constant"
import { CategoryStylingParametersMapper } from "@tfg/types/schemas/communication-studio/stylingParameters"

export const COMPARISON_OPERATORS = {
  EQUALS: "equals",
  NOT_EQUALS: "not_equals",
  IN: "in",
  NOT_IN: "not_in",
  EXISTS: "exists",
  NOT_EXISTS: "not_exists",
} as const
export type ComparisonOperator =
  (typeof COMPARISON_OPERATORS)[keyof typeof COMPARISON_OPERATORS]

export type RuleCondition = {
  configPath: string
  operator: ComparisonOperator
  value: unknown
}

export const SCHEMA_OPERATIONS = {
  PICK: "pick",
  OMIT: "omit",
  PICK_ALL: "pick_all",
} as const
export type SchemaOperation =
  (typeof SCHEMA_OPERATIONS)[keyof typeof SCHEMA_OPERATIONS]

export type SchemaRule = {
  id: string
  description: string
  priority: number
  conditions: RuleCondition[]
  operation: SchemaOperation
  fields: string[]
}
export type CategoryKey = keyof typeof CategoryStylingParametersMapper

export type CategorySchemaRules = {
  category: CategoryKey
  rules: SchemaRule[]
  defaultRule?: Omit<SchemaRule, "conditions">
}

export const SCHEMA_RULES_METADATA: CategorySchemaRules[] = [
  {
    category: CUSTOMISATION_CATEGORIES.ECOSCORE,
    rules: [
      {
        id: "ecoscore-b2b-mode",
        description: "Show only B2B styling when display mode is B2B",
        priority: 10,
        conditions: [
          {
            configPath: "contentFiltering.ecoScoreDisplayMode",
            operator: COMPARISON_OPERATORS.EQUALS,
            value: "b2b",
          },
        ],
        operation: SCHEMA_OPERATIONS.PICK,
        fields: ["ecoscoreB2b"],
      },
      {
        id: "ecoscore-b2c-mode",
        description: "Show only B2C styling when display mode is B2C",
        priority: 5,
        conditions: [
          {
            configPath: "contentFiltering.ecoScoreDisplayMode",
            operator: COMPARISON_OPERATORS.EQUALS,
            value: "b2c",
          },
        ],
        operation: SCHEMA_OPERATIONS.PICK,
        fields: ["ecoscoreAlign"],
      },
    ],
    defaultRule: {
      id: "ecoscore-default",
      description: "Default to B2C styling",
      priority: 0,
      operation: SCHEMA_OPERATIONS.PICK,
      fields: ["ecoscoreAlign"],
    },
  },
]
